// extracted by mini-css-extract-plugin
module.exports = {"marquee":"_34tEH","marquee-text":"_3w1fe","animate":"_3HlLO"};